<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 支出审批</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="审批" prop="status" :rules="[{required: true, type:'number', message: '请选择审批结果', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="5">审批通过</Radio>
                                            <Radio :label="4">驳回申请</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 4">
                                    <FormItem  label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 支出信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="零星项目：">
                                    {{detail.project_name}}
                                </Description>
                                <Description term="甲方：">
                                    {{detail.customer_name ?? '-'}}
                                </Description>
                                <Description term="维保记录：">
                                    {{detail.maintain_title ?? '-'}}
                                </Description>
                                <Description term="供应商：">
                                    {{detail.company ?? '-'}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                                <Description term="不含税金额：">
                                    <Tag color="blue">{{detail.money}}</Tag>
                                </Description>
                                <Description term="费率：">
                                    <Tag>{{detail.tax_rate}} %</Tag>
                                </Description>
                                <Description term="税费：">
                                    <Tag>{{detail.tax_money}}</Tag>
                                </Description>
                                <Description term="含税金额：">
                                    <Tag color="green">{{detail.true_money}}</Tag>
                                </Description>
                                <Description term="模式：">
                                    <Tag>{{detail.mode_name}}</Tag>
                                </Description>
                                <Description term="支出类型：">
                                    <Tag>{{detail.type_name}}</Tag>
                                </Description>
                                <Description term="附件：">
                                    <a href="javascript:void(0);" v-if="detail.image && detail.image.length > 0" @click="FileDownload(detail.image[0])">下载文件</a>
                                    <span v-else>-</span>
                                </Description>
                                <Description term="支出说明：">
                                    {{detail.content || '-'}}
                                </Description>
                                <Description term="收款账户：">
                                    {{detail.pay_bank_account}}
                                </Description>
                                <Description term="账户实名：">
                                    {{detail.pay_bank_real_name}}
                                </Description>
                                <Description term="开户银行：">
                                    {{detail.pay_bank_name}}
                                </Description>
                                <Description term="开户地址：">
                                    {{detail.pay_bank_address}}
                                </Description>
                                <Description term="申请人：">
                                    {{detail.apply_name}}
                                </Description>
                                <Description term="申请时间：">
                                    {{detail.apply_time}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                                <Description term="备注信息：">
                                    {{detail.remark}}
                                </Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认审批</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {examineDispersedExpend, getDispersedExpendDetail} from "@/apis/dispersed";

export default {
    name: 'DispersedExpendExamine',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '支出审批',
            isBox : false,
            detail: [],
            site_url : this.$siteApi,
            Forms : {
                expend_id: '',
                status: '',
                reject_remark: '',
            },
            Rules : {

            }
        }
    },
    methods: {
      /**
       功能：附件下载
       time: 2026/09/12
       **/
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：详情
         time: 2026/09/12
         **/
        GetDetail(expend_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedExpendDetail(expend_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：打开
         time: 2026/09/12
         **/
        show(expend_id){
            this.isBox = true;
            if(expend_id){
                this.Forms.expend_id = expend_id;
                this.GetDetail(expend_id);
            }
        },
        /**
         功能：提交
         time: 2026/09/12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    examineDispersedExpend(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '支出审批';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                expend_id: '',
                status: '',
                reject_remark: '',
            };
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
